<template>
    <div class="space-course wrapper">
        <proTitle></proTitle>
        <el-form :inline="true" :model="formInline" class="demo-form-inline flex-align-between" @submit.native.prevent>
            <div class="formInline-left">
                <el-form-item>
                    <el-input v-model="formInline.search" size="small" clearable placeholder="搜索空间/课程名称"
                        suffix-icon="el-icon-search" style="width: 240px;" />
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formInline.spxId" size="small" clearable filterable placeholder="按空间筛选"
                        style="width: 200px;" @change="filterChange">
                        <el-option label="全部空间" value="" />
                        <el-option v-for="item in spaceOptions" :key="item.id" :label="item.spxName" :value="item.id" />
                    </el-select>
                </el-form-item>
            </div>
            <div class="formInline-right">
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-download" @click="exportFile">导出</el-button>
                </el-form-item>
            </div>
        </el-form>

        <div class="table_section">
            <el-table v-loading="loading" :data="tableData" style="width: 100%" :span-method="objectSpanMethod"
                :row-class-name="tableRowClassName">
                <el-table-column type="index" label="序号" width="80" align="center" :index="indexMethod" />
                <el-table-column prop="spaceName" label="空间名称" align="center" min-width="160" show-overflow-tooltip />
                <el-table-column prop="date" label="日期" align="center" width="140" show-overflow-tooltip />
                <el-table-column prop="weekday" label="星期" align="center" width="100" />
                <el-table-column prop="time" label="时间" align="center" width="140" show-overflow-tooltip />
                <el-table-column prop="courseName" label="课程名称" align="center" min-width="180" show-overflow-tooltip />
            </el-table>
            <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
                :limit.sync="pages.pageSize" :pageSizes="[10, 20, 30]" @pagination="handlePageChange" />
        </div>
    </div>
</template>

<script>
    import { saveAs } from 'file-saver'

    export default {
        data() {
            return {
                loading: true,
                formInline: {
                    search: '',
                    spxId: '',
                },
                spaceOptions: [],
                allTableData: [],
                pages: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
            }
        },
        computed: {
            // 搜索过滤后的全量数据
            filteredTableData() {
                const keyword = (this.formInline.search || '').trim().toLowerCase()
                if (!keyword) return this.allTableData
                return this.allTableData.filter(item => {
                    const spaceName = (item.spaceName || '').toLowerCase()
                    const courseName = (item.courseName || '').toLowerCase()
                    return spaceName.includes(keyword) || courseName.includes(keyword)
                })
            },
            // 当前页数据（前端手动分页）
            tableData() {
                const { currentPage, pageSize } = this.pages
                const start = (currentPage - 1) * pageSize
                return this.filteredTableData.slice(start, start + pageSize)
            },
            // 相邻行日期+星期相同则合并，记录每行 rowspan（0 表示被合并隐藏）
            dateSpanArr() {
                return this.buildSpanArr((item, prev) =>
                    item.date === prev.date && item.weekday === prev.weekday
                )
            },
            // 在日期已合并的前提下，相邻行空间名称相同则合并
            spaceSpanArr() {
                return this.buildSpanArr((item, prev) =>
                    item.date === prev.date
                    && item.weekday === prev.weekday
                    && item.spaceName === prev.spaceName
                )
            },
            // 按日期合并组编号，供斑马纹按组交替（而非按原始行）
            stripeGroupArr() {
                const groups = []
                let groupIndex = -1
                this.dateSpanArr.forEach(span => {
                    if (span > 0) groupIndex += 1
                    groups.push(groupIndex)
                })
                return groups
            },
        },
        watch: {
            'formInline.search'() {
                this.pages.currentPage = 1
                this.pages.total = this.filteredTableData.length
            },
            filteredTableData(val) {
                this.pages.total = val.length
                const maxPage = Math.max(1, Math.ceil(val.length / this.pages.pageSize) || 1)
                if (this.pages.currentPage > maxPage) {
                    this.pages.currentPage = maxPage
                }
            },
        },
        methods: {
            buildSpanArr(isSameGroup) {
                const data = this.tableData
                const spanArr = []
                let pos = 0
                data.forEach((item, index) => {
                    if (index === 0) {
                        spanArr.push(1)
                        pos = 0
                        return
                    }
                    if (isSameGroup(item, data[index - 1])) {
                        spanArr[pos] += 1
                        spanArr.push(0)
                    } else {
                        spanArr.push(1)
                        pos = index
                    }
                })
                return spanArr
            },
            objectSpanMethod({ rowIndex, columnIndex }) {
                // 空间名称列：日期+星期相同且空间名相同则合并
                if (columnIndex === 1) {
                    const rowspan = this.spaceSpanArr[rowIndex]
                    return {
                        rowspan,
                        colspan: rowspan > 0 ? 1 : 0,
                    }
                }
                // 日期列、星期列
                if (columnIndex === 2 || columnIndex === 3) {
                    const rowspan = this.dateSpanArr[rowIndex]
                    return {
                        rowspan,
                        colspan: rowspan > 0 ? 1 : 0,
                    }
                }
            },
            // 同一合并组共用背景色，避免 stripe 按行错乱
            tableRowClassName({ rowIndex }) {
                return this.stripeGroupArr[rowIndex] % 2 === 1 ? 'stripe-row' : ''
            },
            indexMethod(index) {
                return this.pages.currentPage > 1
                    ? this.pages.pageSize * (this.pages.currentPage - 1) + index + 1
                    : index + 1
            },
            filterChange() {
                this.pages.currentPage = 1
                this.fetchList()
            },
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
            },
            async fetchSpaceOptions() {
                try {
                    const res = await this.$Api.Paired.getListByProject({
                        page: 1,
                        limit: 999,
                        projectId: this.$store.state.user.currentProject.id,
                    })
                    this.spaceOptions = (res.data && res.data.records) || []
                } catch (e) {
                    this.spaceOptions = []
                }
            },
            async fetchList() {
                this.loading = true
                try {
                    const res = await this.$Api.Paired.getCourseList({
                        projectId: this.$store.state.user.currentProject.id,
                        spaceIds: this.formInline.spxId
                            ? this.formInline.spxId
                            : this.spaceOptions.map(item => item.id).join(','),
                    })
                    this.allTableData = res.data || []
                    this.pages.currentPage = 1
                    this.pages.total = this.filteredTableData.length
                } catch (e) {
                    this.allTableData = []
                    this.pages.total = 0
                } finally {
                    this.loading = false
                }
            },
            escapeCsv(value) {
                const str = value == null ? '' : String(value)
                if (/[",\n\r]/.test(str)) {
                    return `"${str.replace(/"/g, '""')}"`
                }
                return str
            },
            exportFile() {
                if (!this.filteredTableData.length) {
                    this.$message.warning('暂无数据可导出')
                    return
                }
                const headers = ['序号', '空间名称', '日期', '星期', '时间', '课程名称']
                const rows = this.filteredTableData.map((item, index) => [
                    index + 1,
                    item.spaceName,
                    item.date,
                    item.weekday,
                    item.time,
                    item.courseName,
                ].map(this.escapeCsv).join(','))
                const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n')
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
                saveAs(blob, `空间课程安排_${Date.now()}.csv`)
            },
        },
        async mounted() {
            this.loading = true
            await this.fetchSpaceOptions()
            await this.fetchList()
        },
    }
</script>

<style lang="less" scoped>
    // @import "../manage/less/table.less";

    .space-course {
        padding: 20px 25px;
        box-sizing: border-box;

        .demo-form-inline {
            width: 100%;
            margin: 15px 0;

            /deep/ .el-form-item {
                margin-bottom: 0;
            }
        }

        .table_section {
            margin-top: 10px;
        }
    }

    /deep/ .el-table {
        border-radius: 8px;
        border: 1px solid rgba(199, 199, 199, .43);

        .stripe-row td {
            background-color: #fafafa;
        }
    }

    /deep/ .el-table__header {
        thead th {
            color: #000;
            font-weight: 400;
            background-color: RGBA(250, 251, 255, 1);
            border: 0;
        }
    }
</style>
